document.addEventListener('DOMContentLoaded', function () {
  const widget = document.getElementById('sws-whatsapp-widget');

  if (!widget) return;

  const toggle = document.getElementById('sws-whatsapp-toggle');
  const chat = document.getElementById('sws-whatsapp-chat');
  const close = document.getElementById('sws-whatsapp-close');
  const input = document.getElementById('sws-whatsapp-input');
  const sendFullButton = document.getElementById('sws-whatsapp-send-full');

  // Replace with your actual WhatsApp number
  const whatsappNumber = '971567936878';

  function openChat() {
    chat.hidden = false;
    input.focus();
  }

  function closeChat() {
    chat.hidden = true;
  }

  function getFinalMessage() {
    const customerMessage = input.value.trim();

    if (!customerMessage) {
      return '';
    }

    let message =
      'Hi, I am contacting you from Smell With Stripes.\n\n' +
      customerMessage;

    if (
      window.swsWhatsAppProduct &&
      window.swsWhatsAppProduct.isProduct
    ) {
      message +=
        '\n\nProduct: ' +
        window.swsWhatsAppProduct.title +
        '\nLink: ' +
        window.swsWhatsAppProduct.url;
    }

    return message;
  }

  async function copyMessage() {
    const message = getFinalMessage();

    if (!message) {
      alert('Please enter a message.');
      return;
    }

    try {
      await navigator.clipboard.writeText(message);

      copyButton.textContent = 'Copied!';

      setTimeout(function () {
        copyButton.textContent = 'Copy Message';
      }, 1500);

    } catch (error) {
      const textarea = document.createElement('textarea');

      textarea.value = message;
      document.body.appendChild(textarea);

      textarea.select();
      document.execCommand('copy');

      textarea.remove();

      copyButton.textContent = 'Copied!';

      setTimeout(function () {
        copyButton.textContent = 'Copy Message';
      }, 1500);
    }
  }

  function sendWhatsAppMessage() {
    const message = getFinalMessage();

    if (!message) {
      alert('Please enter a message.');
      return;
    }

    const whatsappUrl =
      'https://wa.me/' +
      whatsappNumber +
      '?text=' +
      encodeURIComponent(message);

    window.open(
      whatsappUrl,
      '_blank',
      'noopener,noreferrer'
    );
  }

  toggle.addEventListener('click', openChat);

  close.addEventListener('click', closeChat);

  sendFullButton.addEventListener(
    'click',
    sendWhatsAppMessage
  );

  input.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      sendWhatsAppMessage();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !chat.hidden) {
      closeChat();
    }
  });
});